
export default {

    state: {
        error: null,
        message: null,
        success: null,
    },

    mutations: {

        setNotice(state, { type, text }) {
            state[ type ] = text;
        },

        clearNotice(state, type) {
            state[ type ] = null;
        }

    },

    actions: {

        setError({ commit }, text) {
            commit('setNotice', { type: 'error', text });
        },

        setMessage({ commit }, text) {
            commit('setNotice', { type: 'message', text });
        },

        setSuccess({ commit }, text) {
            commit('setNotice', { type: 'success', text });
        },

        clearNotice({ commit }, type) {
            commit('clearNotice', type);
        }

    }

};



// WEBPACK FOOTER //
// ./resources/js/store/notices.js